import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import EditDocument from "nlib/common/EditDocument";
import Modal from "nlib/ui/Modal";
import React from "react";

const EditDocumentWindow = ({ documentId, onClose }) => {
  const { uiTexts } = useSelector(getTextsData);

  return (
    <Modal
      noHeader
      iconComponent={Icons.FileText}
      title={uiTexts.editDocument}
      className={Css.editDocumentWindow}
      dialogClassName={Css.modalDialog}
      contentClassName={Css.contentClassName}
      onClose={onClose}>
      <div className={Css.contentWrap}>
        <EditDocument
          openedInWindow
          key={documentId}
          documentId={documentId}
          onClose={onClose} />
      </div>
    </Modal>
  );
};

export default React.memo(EditDocumentWindow);
